/**
 * Lightweight math helpers — replacements for the Phaser.Math utilities the
 * game relied on. Zero dependencies; pure functions.
 */

export const clamp = (v: number, lo: number, hi: number): number =>
  Math.max(lo, Math.min(hi, v));

export const between = (lo: number, hi: number): number =>
  lo + Math.random() * (hi - lo);

export const betweenInt = (lo: number, hi: number): number =>
  Math.floor(between(lo, hi + 1));

export const degToRad = (d: number): number => (d * Math.PI) / 180;

export const radToDeg = (r: number): number => (r * 180) / Math.PI;

export const lerp = (a: number, b: number, t: number): number =>
  a + (b - a) * t;
